import styled from '@emotion/styled'

export const OrderForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const CustomerFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  > :first-of-type,
  > :last-of-type {
    grid-column: 1 / -1;
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;

    > * {
      grid-column: auto;
    }
  }
`

export const TextAreaField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;

  label {
    color: #fff;
    font-size: 13px;
    font-weight: 500;
  }

  span {
    color: #ff8e8e;
    font-size: 12px;
  }
`

export const TextAreaControl = styled.textarea<{ $invalid?: boolean }>`
  width: 100%;
  height: 104px;
  padding: 12px 14px;
  border: 2px solid ${({ $invalid }) => ($invalid ? '#e53935' : '#596170')};
  border-radius: 6px;
  outline: none;
  color: #202327;
  background: #fff;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 16px;
  resize: vertical;
  line-height: 1.4;

  &:hover {
    border-color: #7d8798;
  }

  &:focus {
    border-color: #ff8e00;
    box-shadow: 0 0 0 3px rgba(255, 142, 0, 0.2);
  }
`

export const ConsentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid #596170;
  border-radius: 10px;
  background: #2a303c;
`

export const ConsentField = styled.label<{ $invalid?: boolean }>`
  display: grid;
  grid-template-columns: 22px 1fr;
  gap: 10px;
  align-items: start;
  color: ${({ $invalid }) => ($invalid ? '#ff9b99' : '#fff')};
  cursor: pointer;
  font-size: 13px;
  line-height: 1.45;

  input {
    width: 19px;
    height: 19px;
    margin: 0;
    accent-color: #ff8e00;
  }
`

export const SubmitError = styled.div`
  padding: 12px 14px;
  border: 1px solid #ff7772;
  border-radius: 8px;
  color: #ffd2d0;
  background: rgba(229, 57, 53, 0.14);
  font-size: 13px;
`

export const SubmitButton = styled.button`
  min-height: 50px;
  border: 2px solid #ff9b1a;
  border-radius: 9px;
  color: #202327;
  background: #ff9b1a;
  cursor: pointer;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: #ffc36f;
    outline: none;
    background: #ffad42;
  }

  &:disabled {
    border-color: #596170;
    color: #8f9aab;
    background: #2a2f38;
    cursor: not-allowed;
  }
`

export const OrderSuccess = styled.div`
  padding: 22px;
  border: 1px solid #46c28a;
  border-radius: 12px;
  text-align: center;
  background: rgba(46, 139, 87, 0.16);

  strong,
  span {
    display: block;
  }

  strong {
    color: #78e1ad;
    font-size: 20px;
  }

  span {
    margin-top: 8px;
    color: #d7dfeb;
    font-size: 13px;
  }

  code {
    display: inline-block;
    padding: 7px 10px;
    border-radius: 6px;
    color: #ffbf69;
    background: #202631;
    overflow-wrap: anywhere;
  }
`

export const OrderSuccessActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    padding: 0 14px;
    border: 1px solid #ff9b1a;
    border-radius: 7px;
    color: #202327;
    background: #ff9b1a;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
  }

  a:hover {
    border-color: #ffb34f;
    background: #ffb34f;
  }

  @media (max-width: 520px) {
    flex-direction: column;

    a,
    code {
      width: 100%;
      box-sizing: border-box;
    }
  }
`
